<template>
    <div class="cbs-vehicle-list clearfix">
        <ul>
            <li v-for="(item, index) in availableVehicles" class="clearfix">
                <div class="cbs-vehicle-image float-left">
                    <img v-bind:src="item.imageUrl" v-bind:alt="item.className + '-' + item.equivalent">
                </div>

                <div class="cbs-vehicle-content float-left">
                    <div class="cbs-vehicle-content-header">
                        <h2>
                            <span class="cbs-vehicle-content-price">
                                <span><sup class="cbs-vehicle-content-price-currency">{{item.currency}}</sup>{{getPriceAsInt(item.carPrice)}}<sup>{{getPriceDecimals(item.carPrice)}}</sup></span>
                            </span>
                            -
                            <span class="cbs-vehicle-content-car-name">{{item.className}}</span>
                        </h2>

                        <button type="button" v-on:click="selectCar(item)" class="btn btn-primary cbs-vehicle-content-select-btn">Select</button>
                    </div>
                    <div class="cbs-vehicle-content-equivalent">
                        {{item.equivalent}}
                    </div>

                    <div class="chbs-vehicle-content-meta">
                        <div class="chbs-vehicle-content-meta-info">
                            <div>
                                <img class="cbs-car-info-icon" src="../../../../../content/images/components/users.png" />
                                <span class="chbs-circle"> Max <b>{{item.numberOfPassengers}}</b> passengers</span>

                                <img class="cbs-car-info-icon ml-20" src="../../../../../content/images/components/portmanteau.png" />
                                <span class="chbs-circle"> Max <b>{{item.numberOfLuggages}}</b> standard bags</span>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "VehiclesVerticalList",
        components: {},
        computed: {
            availableVehicles: function () {
                return this.$store.state.bookingInfo.availableCars;
            }
        },
        methods: {
            selectCar: function (item) {
                console.log(item);
                //this.$store.dispatch('getBookingPrice');
                return this.$store.commit("setSelectedCar", item);
            },
            getPriceDecimals: function (price) {
                var radixPos = String(price).indexOf('.');
                if (radixPos < 0)
                    return '.00';

                var value = String(price).slice(radixPos);
                if (value.length < 3) //ex '.5' .. if price is 38.5
                    value += '0';

                return value;
            },
            getPriceAsInt: function (price) {
                return Math.floor(price);
            }
        }
    }
</script>

<style>
    .cbs-vehicle-list {
        width: 100%;
        background-color: #fff;
    }
        .cbs-vehicle-list ul { padding: 0; }

        .cbs-vehicle-list ul li {
            list-style-type: none;
            width: 100%;
            border-bottom: 1px solid #8080803b;
            padding-top: 30px;
            padding-bottom: 20px;
            position: relative;
        }

            .cbs-vehicle-list ul li:last-child {
                border-bottom: none;
            }

        .cbs-vehicle-list .cbs-vehicle-image {
            max-width: 190px;
            min-height: 150px;
        }

            .cbs-vehicle-list .cbs-vehicle-image img {
                width: 100%;
                margin: 0 auto;
            }

    .cbs-vehicle-content {
        margin-left: 30px;
    }

        .cbs-vehicle-content .cbs-vehicle-content-header h2 {
            display: inline-block;
            margin-bottom: 5px;
        }

    .cbs-vehicle-content-price .cbs-vehicle-content-price-currency {
        font-size: 12px;
        top: -2em;
    }

    .cbs-vehicle-content .cbs-vehicle-content-car-name {
        color: black;
    }

    .cbs-vehicle-content .cbs-vehicle-content-select-btn {
        position: absolute;
        top: 20px;
        right: 20px;
    }

    .cbs-vehicle-content .cbs-vehicle-content-equivalent {
        font-size: 15px;
        font-style: italic;
        margin-top: -10px;
        margin-bottom: 20px;
    }

    .cbs-vehicle-content .cbs-car-info-icon {
        max-height: 25px;
    }
   
    @media only screen and (max-width: 760px){
        .cbs-vehicle-content .cbs-vehicle-content-car-name {
            font-size: 24px;
        }
    }
</style>